import plasticVinylSrc from '@/assets/icons/plastic-vinyl.svg'
import { SEALED_VINYL_SHEETS_PER_PACK } from '@/pages/SealedVinylPage/lib/constants'

import { ItemImage, ItemQuantity, ItemRow, ItemSectionContainer, ItemSectionHeading, ItemTitle } from './styles'

interface ItemSectionProps {
  quantity: number
}

export function ItemSection({ quantity }: ItemSectionProps) {
  return (
    <ItemSectionContainer>
      <ItemSectionHeading>신청 정보</ItemSectionHeading>
      <ItemRow>
        <ItemImage
          src={plasticVinylSrc}
          alt='밀봉비닐'
        />
        <ItemTitle>밀봉 비닐 (1개 당 {SEALED_VINYL_SHEETS_PER_PACK}장)</ItemTitle>
        <ItemQuantity>{quantity}개</ItemQuantity>
      </ItemRow>
    </ItemSectionContainer>
  )
}
